import { Tag } from '@factorialco/deprecated-design-system'
import {
  FilterType,
  buildPerformanceInsightsSummaryDatatableFilter,
  usePerformanceInsightsSummaryDatatable,
} from 'generated/resources/datatable.graphql'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { tagPropsForEmployeeScore } from 'modules/performance_process/lib/employeeScoreColor'

import { SCALE } from './scales'

type Option = { label: string; component: React.ReactNode; value: string }

const scoreFilter = (source: ReturnType<typeof usePerformanceInsightsSummaryDatatable>) => {
  const options: Option[] = []
  const labels: Record<string, string> = {
    not_meet_expectactions: i18n.t(
      'performance_process.analytics.datatable.filters.not_meet_expectactions'
    ),
    below_expectations: i18n.t(
      'performance_process.analytics.datatable.filters.below_expectations'
    ),
    meet_expectations: i18n.t('performance_process.analytics.datatable.filters.meet_expectations'),
    exceeds_expectations: i18n.t(
      'performance_process.analytics.datatable.filters.exceeds_expectations'
    ),
    outstanding: i18n.t('performance_process.analytics.datatable.filters.outstanding'),
  }

  Object.entries(SCALE).forEach(([key, value], i) => {
    const label = labels[key]

    if (!label) throw 'Performance label is missing'

    options.push({
      label: '',
      component: (
        <Tag leftItem="circle" showCircle {...tagPropsForEmployeeScore(i + 1, 5)}>
          {label}
        </Tag>
      ),
      value: value.join('#'),
    })
  })

  return buildPerformanceInsightsSummaryDatatableFilter(source, {
    title: i18n.t('performance_process.analytics.datatable.filters.potential'),
    path: 'potentialScoreRange',
    identifier: 'potentialScoreRange',
    type: FilterType.String,
    categories: [
      {
        kind: 'MultipleChoice',
        operation: 'in',
        options: options,
      },
    ],
    onUpdateValue(value) {
      track(trackingEvents.performanceAnalytics.insightsSummaryFilterApplied, {
        type: 'potentialScoreRange',
        value,
      })
    },
  })
}

export default scoreFilter
